var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3852 13.528L15.2072 0.349976C14.9823 0.126474 14.678 0.0010376 14.361 0.0010376C14.044 0.0010376 13.7399 0.126474 13.515 0.349976L0.336085 13.529C0.137439 13.7569 0.0320611 14.0514 0.041163 14.3536C0.0502649 14.6558 0.173155 14.9434 0.385157 15.1589C0.597159 15.3745 0.882718 15.502 1.18472 15.5161C1.48672 15.5302 1.7829 15.4298 2.01406 15.235V27.549C2.01406 27.8673 2.14058 28.1725 2.36563 28.3975C2.59067 28.6226 2.89575 28.749 3.21401 28.749H25.5141C25.8323 28.749 26.1377 28.6226 26.3627 28.3975C26.5877 28.1725 26.714 27.8673 26.714 27.549V15.233C26.9454 15.422 27.239 15.5179 27.5373 15.502C27.8356 15.486 28.1171 15.3594 28.3271 15.1469C28.537 14.9344 28.6601 14.6512 28.6723 14.3527C28.6845 14.0543 28.5848 13.7619 28.393 13.533L28.3852 13.528ZM17.2182 26.353H11.5021H17.2182ZM9.10806 26.353H4.40811V12.84L14.362 2.88696L24.3161 12.84V26.353H9.11099H9.10806Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHouse);
export default __webpack_public_path__ + "static/media/ico-house.c2d28ee7.svg";
export { ForwardRef as ReactComponent };